import { contentApi } from '../index';
import { apiRoutes } from '../apiRoutes';
import { CropFamiliesData } from './types';

export const getCropFamiliesData = async () => {
  const response = await contentApi.get<CropFamiliesData>(apiRoutes.cropsFamilies);
  return response?.data;
};
